<template>
  <div class="w-fit-content bg-color-9 color-white open-sans-bold nowrap" style="font-size: 0.75rem; padding: 0.11rem 0.41rem; border-radius: 2px">
    {{ $t("rsf_new") }}
  </div>
</template>

<script>
export default {
  name: "NewBadge",
};
</script>

<style scoped>
@media (max-width: 480px) {
  div {
    font-size: calc(0.5rem + 1.05vw * 0.4) !important;
  }
}
</style>
